import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { v4 as uuid } from "uuid";
import { DBMigrate } from "./db-migration";

declare let SecureStorage: any;

@Injectable()
export class DatabaseProvider {
  private _db: any;
  private _secretKey: any;
  private _dbName: string;
  private _secureStorage: any;
  private _secureStorageName: string = "curantis_secure_data";
  private _storageKeyName: string = "sqlite_key";

  constructor(public eventCtrl: Events) {
    this._dbName = "curantis_sqlite.db";
  }

  public setSecretKey(secretKey: any) {
    this._secretKey = secretKey;
  }

  public isReady(): boolean {
    return this._db ? true : false;
  }

  public getInstance(): Observable<any> {
    return new Observable((observer) => {
      if (this._db) {
        observer.next(this._db);
        observer.complete();
      } else {
        observer.error({ message: "SQLite is not initialized" });
      }
    });
  }

  public initializeSQLiteDB(): Observable<any> {
    return new Observable((observer) => {
      if (!this._db && !this._secretKey) {
        this.createSecureStorage().subscribe((success) => {
          this.getFromSecureStorage(this._storageKeyName).subscribe(
            (appdbkey) => {
              if (!appdbkey) {
                appdbkey = this.generateSereteKey();
                this.setInSecureStorage(this._storageKeyName, appdbkey);
              }
              this.setSecretKey(appdbkey);
              this._db = this.initSQLite();
              observer.next(this._db);
              observer.complete();
            },
            (error) => {
              console.log("From Secure Storage read ERROR" + error);
            }
          );
        });
      } else if (!this._db && this._secretKey) {
        this._db = this.initSQLite();
        observer.next(this._db);
        observer.complete();
      } else {
        observer.next(this._db);
        observer.complete();
      }
    });
  }

  public initSQLite(): any {
    try {
      this._db = (<any>window).sqlitePlugin.openDatabase({
        name: this._dbName,
        key: this._secretKey,
        location: "default",
      });
      // Execute Migrations
      this.runMigration(this._db);
      return this._db;
    } catch (error) {
      console.log("Sqlite database connection failed", error);
    }
  }

  public runMigration(db: any) {
    let dbMigrate = new DBMigrate();
    dbMigrate.createSchema(db);
  }

  private generateSereteKey(): string {
    return uuid().substring(0, 8);
  }

  public createSecureStorage(): Observable<any> {
    return new Observable((observer) => {
      this._secureStorage = new SecureStorage(
        () => {
          console.log("succesfully created secureStorage");
          observer.next(true);
          observer.complete();
        },
        (error) => {
          console.log("Error creating secureStorage: " + error);
          observer.next(error);
          observer.complete();
        },
        this._secureStorageName
      );
    });
  }

  private getFromSecureStorage(key): Observable<any> {
    return new Observable((observer) => {
      this._secureStorage.get(
        (value) => {
          console.log("succesfully retrieved " + key + " from secureStorage.");
          observer.next(value);
          observer.complete();
        },
        (error) => {
          console.log(
            "Error retrieving " + key + " from secureStorage: " + error
          );
          observer.next(null);
          observer.complete();
        },
        key
      );
    });
  }

  private setInSecureStorage(key, value) {
    this._secureStorage.set(
      () => console.log("succesfully set " + key + " in secureStorage"),
      (error) =>
        console.log("Error setting " + key + " secureStorage: " + error),
      key,
      value
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/offline-database/db-connection.ts